import { LoaderFunction, useLoaderData } from "remix";
import { ContentBlock } from "~/components/ContentBlock";
import { ContentBlockModel, getContentBlock } from "~/utils/contentBlocks";
import { useIsLoggedIn } from "~/utils/useIsLoggedIn";

export interface LoaderProps {
  blockContent: ContentBlockModel;
}

export const createContentBlockPageLoader =
  (slug: string): LoaderFunction =>
  async ({ request }) => {
    const blockContent = await getContentBlock(slug);

    return { blockContent };
  };

export const createContentBlockPage = () => () => {
  const { blockContent } = useLoaderData<LoaderProps>();
  const isLoggedIn = useIsLoggedIn();

  return (
    <div className="main-layout-centered my-6">
      <ContentBlock block={blockContent} editable={isLoggedIn} />
    </div>
  );
};
